{
  "version": 1,
  "asset_id": "1dbcaf96-2673-45bd-8463-ea7edb93fe42",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/1dbcaf96-2673-45bd-8463-ea7edb93fe42/crystal-river-blue-shingle-roof-destination-roofing-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/1dbcaf96-2673-45bd-8463-ea7edb93fe42/crystal-river-blue-shingle-roof-destination-roofing-768w.webp",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-768w.webp",
  "size": 49690,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:47Z"
}
